import { render, staticRenderFns } from "./TitleSChapter.vue?vue&type=template&id=63dc1852&scoped=true&"
import script from "./TitleSChapter.vue?vue&type=script&lang=js&"
export * from "./TitleSChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc1852",
  null
  
)

export default component.exports